import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './primitives.css'

/**
 * The list container for composed [Pagination](/components/pagination/) controls.
 * Lays its [Pagination Item](/components/pagination-item/) children out in a row.
 *
 * Place it inside [Pagination](/components/pagination/), which is already the
 * `navigation` landmark (it sets `role="navigation"` and an accessible label).
 * Do not add your own `<nav>` wrapper — a second landmark around the same
 * controls would be a duplicate that screen-reader users have to wade through.
 *
 * @status draft
 * @category navigation
 * @lightDom true
 *
 * @slot - Default slot for Pagination Item children.
 */
@customElement('nord-pagination-content')
export default class PaginationContent extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-pagination-content': PaginationContent
  }
}
